// English: the reference. Every other language file uses the same keys;
// anything missing there falls back to the text here.
// Glossary terms default to the English text in features/glossary.js.

export default {
    // Research papers page (/research)
    "nav.globe": "Globe",
    "nav.research": "Research",
    "rs.title": "Research papers",
    "rs.sub": "New quantitative-finance and central-bank research from arXiv, the Fed, the ECB, the BIS and NBER. Free to read at the source; updated every 6 hours.",
    "rs.search": "Search titles, authors, summaries…",
    "rs.allTopics": "All topics",
    "rs.allSources": "All sources",
    "rs.allCountries": "All countries",
    "rs.count": "{n} papers",
    "rs.none": "No papers match these filters.",
    "rs.clear": "Clear filters",
    "rs.download": "Download PDF from {source}",
    "rs.read": "Read at {source}",
    "rs.onGlobe": "Open {country} on the globe",
    "rs.note": "Titles, authors and summaries link to the original publishers; PDFs open on their websites. Research, not financial advice.",
    "rs.global": "Global",
    "rs.loadMore": "Load more",
    "rs.details": "Details",
    "rs.copy": "Copy link",
    "rs.copied": "Link copied",
    "rs.published": "Published",
    "panel.research": "Research about {country}",
    "panel.researchAll": "All research →",
    "rt.trading": "Trading & market structure",
    "rt.portfolio": "Portfolios & investing",
    "rt.risk": "Risk",
    "rt.pricing": "Derivatives & pricing models",
    "rt.forecasting": "AI & forecasting",
    "rt.crypto": "Crypto & digital assets",
    "rt.macro": "Economy & central banks",
    "topic.r-trading": "Trading research studies how prices form and how orders are executed: strategies, order books, liquidity and trading costs.",
    "topic.r-portfolio": "Portfolio research asks how to combine investments: which factors explain returns, how to balance risk and return, and how to invest for retirement.",
    "topic.r-risk": "Risk research measures what can go wrong: big losses, market crashes, bank failures and how to protect against them.",
    "topic.r-pricing": "Pricing research builds the maths that values options and other contracts, and the models behind volatility.",
    "topic.r-forecasting": "AI and forecasting research tests whether machine learning, language models and statistics can predict prices or the economy, and how reliably.",
    "topic.r-crypto": "Crypto research studies cryptocurrencies, stablecoins, blockchains and tokenized assets: how they trade and what risks they carry.",
    "topic.r-macro": "Economic research looks at growth, inflation, interest rates and central-bank policy, which drive markets over months and years.",
    'lang.label': 'Language',
    'nav.reports': 'Get Reports',
    'nav.stocks': 'Stock Watch',
    loading: 'Loading world news…',
    'err.title': 'Unable to load',
    'err.msg': 'Something went wrong while loading the application.',
    'err.retry': 'Try again',
    atlas: 'Atlas',
    'search.label': 'Search countries',
    'search.ph': 'Search countries or codes…',
    'filter.region': 'Region',
    'filter.allRegions': 'All regions',
    'filter.window': 'Window',
    'filter.topic': 'Topic',
    'filter.all': 'All',
    'stage.title': 'Markets, right now',
    legend: 'Legend',
    lastUpdate: 'Last update',
    pauseRotation: 'Pause rotation',
    resumeRotation: 'Resume rotation',
    hint: 'Drag to rotate · click a pin to open a country',
    'panel.latest': 'Latest',
    'quiet.none': 'No stories in this window.',
    'quiet.sub': 'Try a wider time range (7D or 30D), or follow this country to keep it on your list.',
    'footer.about': 'About',
    'footer.privacy': 'Privacy',
    'footer.terms': 'Terms',
    follow: '☆ Follow',
    following: '★ Following',
    followingGroup: 'Following',
    explain: 'Explain this',
    hideExplain: 'Hide explanation',
    share: 'Share',
    whyMatter: 'Why it can matter',
    disclaimer: 'Educational context, not financial advice.',
    readAt: 'Read full story at {source}',
    translate: 'Translate',
    showing: 'Showing {n} of {total}',
    loadMore: 'Load {n} more',
    loadingShort: 'Loading…',
    'story.one': '{n} story',
    'story.other': '{n} stories',
    noStories: 'no stories',
    justNow: 'Just now',
    minAgo: '{n}m ago',
    hAgo: '{n}h ago',
    dAgo: '{n}d ago',
    'range.24h': 'last 24 hours',
    'range.7d': 'last 7 days',
    'range.30d': 'last 30 days',
    'range.all': 'all time',
    'cont.Africa': 'Africa',
    'cont.Asia': 'Asia',
    'cont.Europe': 'Europe',
    'cont.North America': 'North America',
    'cont.Oceania': 'Oceania',
    'cont.South America': 'South America',
    'cat.markets': 'Markets',
    'cat.economy': 'Economy',
    'cat.central-banks': 'Central banks',
    'cat.policy': 'Policy & Geopolitics',
    'cat.companies': 'Companies',
    today: 'Today',
    'today.top': 'The world in 60 seconds',
    'today.banks': 'Central-bank decisions',
    'today.mine': 'Your countries',
    'today.emptyTop': 'No major stories yet today. Check back soon.',
    'today.emptyMine': 'Tap ☆ Follow on any country to pin it here.',
    'today.note': 'Headlines link to the original publishers. Educational context only, not financial advice.',
    'today.open': 'Open {country}',
    close: 'Close',
    'cal.timeVaries': 'time varies',
    'cal.yourTime': '{time} your time',
    'cal.in': 'in {t}',
    'cal.today': 'Decision announced today',
    'bank.fed': 'Federal Reserve',
    'bank.ecb': 'European Central Bank',
    'bank.boe': 'Bank of England',
    'bank.boj': 'Bank of Japan',
    'auth.signIn': 'Sign in',
    'auth.account': 'Account',
    'auth.btnTitle': 'Free account: save your countries on every device',
    'auth.freeTitle': 'Free account',
    'auth.freeSub': "Save the countries you follow on all your devices. No password: we email you a one-time code.",
    'auth.emailBtn': "Email me a sign-in code",
    'auth.sending': 'Sending…',
    'auth.check': 'Check your inbox for the sign-in link (it expires in 20 minutes).',
    "auth.codeTitle": "Check your email",
    "auth.codeSent": "We sent a 6-digit code to {email}. Type it here:",
    "auth.codeLabel": "Sign-in code",
    "auth.codeBtn": "Sign in",
    "auth.junk": "Can't see it? It can take a minute. Look in your Spam or Junk folder too, and mark it as \"Not spam\" so our next emails reach your inbox.",
    "auth.otherEmail": "Use a different email",
    'auth.dev': 'Development mode (no email server):',
    'auth.devLink': 'click here to sign in',
    'auth.fine': 'We only use your email to sign you in. See the {link}.',
    'auth.privacy': 'privacy notice',
    'auth.yourAccount': 'Your account',
    'auth.signedInAs': 'Signed in as {email}',
    'auth.followCount': 'Following {n} countries, synced across your devices.',
    'auth.signOut': 'Sign out',
    'auth.delete': 'Delete my account',
    "auth.confirmDelete": "Delete your account? This erases your email address and saved countries, and removes you from NewsNetWide emails. It can’t be undone.",
    'auth.deletedTitle': 'Account deleted',
    "auth.deletedSub": "Your email, your saved countries and your email subscription have been erased.",
    'auth.inTitle': "You're signed in",
    'auth.inSub': 'Welcome, {email}. The countries you follow are now saved to your account.',
    'auth.expired': 'That link has expired. Request a new one below.',
    'auth.used': 'That link has already been used or is invalid. Request a new one below.',
    'share.source': 'Source',
    'share.tagline': 'Every market-moving story, on one globe',
    'share.notAdvice': 'News, not financial advice',
    'mc.open': 'Open',
    'mc.pre': 'Pre-market',
    'mc.post': 'After-hours',
    'mc.night': 'Night session',
    'mc.break': 'Lunch break',
    'mc.closed': 'Closed',
    'mc.holiday': 'Holiday',
    'mc.closesIn': 'Closes in {t}',
    'mc.opensIn': 'Opens in {t}',
    'mc.endsIn': 'Ends in {t}',
    'mc.reopensIn': 'Reopens in {t}',
    'mc.preIn': 'Pre-market in {t}',
    'mc.afterIn': 'After-hours in {t}',
    'mc.nightIn': 'Night session in {t}',
    'mc.openCount': '{n} open',
    'mc.all': 'All markets',
    "mc.title": "Market hours",
    "side.countries": "Countries",
    "side.menu": "Menu",
    "tools.pricingSub": "Plans and what each one includes",
    'mc.noHolidays': 'holidays not included',
    'mc.local': 'local',
    'mc.note': 'Regular trading hours in each exchange’s local time. Holiday calendars are included for US, UK, German and Euronext Paris markets (2026–27); other exchanges may be closed on local holidays. Night sessions are index-futures sessions (Tokyo OSE, Hong Kong HKFE).',
    // Topic explanations (shown in "Explain this")
    'topic.markets': 'Market news covers prices of stocks, bonds, currencies and commodities: what investors are buying and selling, and why.',
    'topic.economy': 'Economic news (growth, jobs, inflation, trade) shapes company profits and central-bank decisions over the coming months.',
    'topic.central-banks': 'Central banks set interest rates, the price of money, which affects loans, savings, currencies and asset prices.',
    'topic.policy': 'Government decisions (taxes, budgets, trade rules, sanctions, elections, conflicts) can change costs and risks for whole industries.',
    'topic.companies': 'Company news (results, deals, job cuts) can move that company’s shares and sometimes its whole sector.',
    "snap.title": "Investor snapshot",
    "snap.source": "Latest official annual figures · World Bank Open Data. Context, not a forecast or advice.",
    "snap.gdp_growth": "GDP growth",
    "snap.inflation": "Inflation",
    "snap.unemployment": "Unemployment",
    "snap.gdp_per_capita": "GDP per person",
    "snap.current_account": "Current account",
    "snap.exports": "Exports",
    "snap.ofGdp": "of GDP",
    "snap.gdp.shrink": "The economy is shrinking.",
    "snap.gdp.slow": "Slow growth.",
    "snap.gdp.moderate": "Moderate growth.",
    "snap.gdp.fast": "Fast growth.",
    "snap.inf.deflation": "Prices are falling (deflation).",
    "snap.inf.target": "Close to the ~2% most central banks aim for.",
    "snap.inf.above": "Above the usual central-bank targets.",
    "snap.inf.high": "High inflation: money loses value quickly.",
    "snap.unemp.low": "Low: the job market is tight.",
    "snap.unemp.moderate": "Moderate.",
    "snap.unemp.high": "High: many people can’t find work.",
    "snap.gdppc.note": "Average output per person: a rough measure of how wealthy a country is.",
    "snap.ca.surplus": "Surplus: earns more from abroad than it spends.",
    "snap.ca.deficit": "Deficit: spends more abroad than it earns, so it relies on foreign money.",
    "snap.exp.very": "Very trade-dependent: sensitive to tariffs and global demand.",
    "snap.exp.open": "An open, trading economy.",
    "snap.exp.domestic": "Driven mostly by its home market.",
    "auth.since": "Member since {date}",
    "auth.followed": "Countries you follow",
    "auth.noneFollowed": "None yet. Tap ☆ Follow on any country to add it here.",
    "auth.unfollow": "Stop following {country}",
    "auth.email": "Email",
    "auth.prefUpdates": "NewsNetWide updates",
    "auth.prefUpdatesSub": "New features and news about the site",
    "auth.prefNews": "Newsletter",
    "auth.prefNewsSub": "Market-news highlights",
    "auth.saved": "Saved.",
    "auth.prefsError": "Email settings are unavailable right now.",
    "auth.plan": "Plan",
    "auth.seePlans": "See plans",
    "auth.manage": "Manage subscription",
    "auth.trialUntil": "free trial until {date}",
    "auth.renews": "renews {date}",
    "auth.endsOn": "ends {date}",
    "auth.briefing": "Morning briefing",
    "auth.briefingOn": "Email me a morning briefing",
    "auth.briefingSub": "Top stories from the countries you follow, plus key dates coming up. You can stop any time.",
    "auth.briefingNone": "You don't follow any countries yet, so it starts with the world's top stories.",
    "auth.briefingCount": "Countries in your briefing: {n}",
    "auth.briefingAt": "Send it at",
    "auth.briefingTz": "your time ({tz})",
    "auth.briefingPreview": "See today's example ↗",
    "panel.page": "Country page ↗",
    "footer.countries": "Countries",
    // Calendar (/calendar, country panel "Coming up")
    "nav.calendar": "Calendar",
    "nav.tools": "Tools",
    "nav.pricing": "Pricing",
    "tools.soon": "SOON",
    "tools.briefing": "Morning briefing",
    "tools.briefingSub": "Your countries' news by email, every morning",
    "tools.calculators": "Financial calculators",
    "tools.calculatorsSub": "Compound interest, savings goals, fees",
    "tools.holdings": "Holdings watch",
    "tools.holdingsSub": "The news about the companies you hold",
    "tools.papers": "Paper analyser",
    "tools.papersSub": "Any research paper, explained in plain English",
    "tools.montecarlo": "Monte Carlo simulator",
    "tools.montecarloSub": "Savings, trading and options strategies, with PDF",
    "cal.title": "Economic calendar",
    "cal.sub": "Central-bank decisions, key economic data, market closures and public holidays, from official sources, in your time zone.",
    "cal.todayLabel": "Today",
    "cal.tomorrow": "Tomorrow",
    "cal.allDay": "All day",
    "cal.now": "now",
    "cal.inDH": "in {d} d {h} h",
    "cal.inHM": "in {h} h {m} min",
    "cal.inM": "in {m} min",
    "cal.decision": "{bank}: interest-rate decision",
    "cal.closed": "{exchange} closed",
    "cal.early": "{exchange} closes early",
    "cal.estimated": "estimated date",
    "cal.yourTz": "Times in your time zone ({tz})",
    "cal.type.public_holiday": "Public holidays",
    "cal.allCountries": "All countries",
    "cal.yourCountries": "Your countries",
    "cal.noFollows": "Follow countries on the globe to filter by them here.",
    "cal.addToCal": "Add to calendar",
    "cal.subscribe": "Subscribe",
    "cal.subscribeHint": "Copy this link into Google Calendar, Apple Calendar or Outlook (“add from URL”). It updates itself.",
    "cal.copied": "Link copied",
    "cal.source": "Official source",
    "cal.relatedNews": "News for {country}",
    "cal.period": "Period: {period}",
    "cal.none": "Nothing scheduled for these filters.",
    "cal.error": "The calendar is unavailable right now. Please try again in a moment.",
    "cal.comingUp": "Coming up",
    "cal.fullCalendar": "Full calendar",
    "cal.euroArea": "Euro area",
    "cal.note": "Dates and times come from each central bank, exchange and statistics office (links on every event). Public holidays: open-source “holidays” library (MIT). We never show forecasts. News and context, not financial advice.",
    "cal.series.us_cpi": "US consumer prices (CPI)",
    "cal.series.us_jobs": "US jobs report",
    "cal.series.us_ppi": "US producer prices (PPI)",
    "cal.series.us_jolts": "US job openings (JOLTS)",
    "cal.series.us_eci": "US employment cost index",
    "cal.series.us_gdp": "US GDP",
    "cal.series.us_pce": "US personal income & spending (PCE)",
    "cal.series.us_trade": "US trade balance",
    "cal.series.ea_hicp_flash": "Euro-area inflation (flash)",
    "cal.series.ea_hicp": "Euro-area inflation (final)",
    "cal.series.ea_gdp_flash": "Euro-area GDP (preliminary flash)",
    "cal.series.ea_gdp": "Euro-area GDP and employment",
    "cal.series.ea_unemployment": "Euro-area unemployment",
    "cal.series.ea_retail": "Euro-area retail sales",
    "cal.series.uk_cpi": "UK consumer prices (CPI)",
    "cal.series.uk_gdp_q": "UK GDP (quarterly)",
    "cal.series.uk_gdp_m": "UK GDP (monthly)",
    "cal.series.uk_jobs": "UK labour market",
    "cal.series.uk_retail": "UK retail sales",
    "cal.series.au_cpi": "Australian consumer prices (CPI)",
    "cal.series.au_jobs": "Australian labour force",
    "cal.series.au_gdp": "Australian GDP",
    "bank.snb": "Swiss National Bank",
    "bank.boc": "Bank of Canada",
    "bank.rba": "Reserve Bank of Australia",
    "bank.rbnz": "Reserve Bank of New Zealand",
    "bank.riksbank": "Sveriges Riksbank",
    "bank.norges": "Norges Bank",
    "bank.rbi": "Reserve Bank of India",
    "cal.promise1": "Official sources only",
    "cal.promise2": "No forecasts, just dates and results",
    "cal.promise3": "Free calendar feed",
    "cal.yourTimeShort": "your time",
    "cal.unitD": "days",
    "cal.unitH": "h",
    "cal.unitM": "min",
    "cal.approxNote": "Approximate time: the bank doesn't fix it in advance",
    "cal.then": "Then:",
    "cal.nextDecisions": "Next rate decisions",
    "cal.bankCalendars": "Official bank calendars · countdown to the announcement",
    "cal.marketsWeek": "Stock markets this week",
    "cal.mktAside": "Closures this week: {n} · times in {tz}",
    "cal.mktNote": "Main trading session only. Closures come from each exchange's official holiday list.",
    "cal.exchange": "Exchange",
    "cal.rightNow": "Right now",
    "cal.mkt.open": "Open",
    "cal.mkt.pre": "Not open yet",
    "cal.mkt.break": "Lunch break",
    "cal.mkt.closedToday": "Closed today",
    "cal.mkt.closed": "Closed",
    "cal.mkt.closesAt": "closes {time} your time",
    "cal.mkt.opensAt": "opens {time} your time",
    "cal.mkt.earlyAt": "Closes early {time}",
    "cal.local": "local",
    "cal.country": "Country",
    "cal.types": "Event types",
    "cal.group.central_bank": "Central banks",
    "cal.group.data_release": "Economic data",
    "cal.group.markets": "Market closures",
    "cal.group.public_holiday": "Public holidays",
    "cal.badge.central_bank": "Rate decision",
    "cal.badge.data_release": "Data release",
    "cal.badge.market_closed": "Market closed",
    "cal.badge.early_close": "Early close",
    "cal.badge.public_holiday": "Public holiday",
    "cal.closesEarly": "closes early",
    "cal.noTrading": "no trading all day",
    "cal.released": "Released",
    "cal.seeFigure": "See the official figure",
    "cal.sourceShort": "Source",
    "cal.news": "News",
    "cal.openNote": "{exchange} open",
    "cal.plusMore": "+{n} more",
    "cal.yesterday": "Yesterday",
    "cal.oneEvent": "1 event",
    "cal.nEvents": "{n} events",
    "cal.oneHoliday": "1 holiday",
    "cal.nHolidays": "{n} holidays",
    "cal.nowLine": "Now · {time}",
    "cal.weekendClosed": "Weekend: stock markets closed.",
    "cal.nothingDay": "Nothing scheduled.",
    "cal.thisWeek": "This week",
    "cal.nextWeekLabel": "Next week",
    "cal.earlier": "Earlier this week",
    "cal.show": "Show",
    "cal.tryAll": "Try all event types, or switch off “Your countries”.",
    "cal.reset": "Reset filters",
    "cal.prevWeek": "Previous week",
    "cal.nextWeek": "Next week",
    "cal.moreWeek": "Show the following week",
    "cal.subscribeTitle": "Subscribe to this calendar",
    "cal.feedAddress": "Feed address",
    "cal.copyLink": "Copy link",
    "cal.subFine": "Free, no account needed. It follows the filters you chose. News and context, not financial advice.",
    "cal.impact": "Impact",
    "cal.imp.high": "High",
    "cal.imp.medium": "Medium",
    "cal.imp.low": "Low",
    "cal.impTip.high": "usually moves rates, currencies and stocks",
    "cal.impTip.medium": "watched by markets, moves them less often",
    "cal.impTip.low": "background: holidays, minor data",
    "cal.impNote": "Based on the type of event, not a forecast.",
    "cal.impAll": "All",
    "cal.impMediumUp": "Medium +",
    "cal.impHighOnly": "High only",
    "cal.nHigh": "{n} high impact",
    "cal.addShort": "Add",
};
